import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useConfig } from '../../../contexts/config-context';
import { useTranslation } from '../../../contexts/translation-context';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { createOption } from '../../../ui/autocomplete/autocomplete';
import { DropdownAutocomplete } from '../../../ui/dropdown-autocomplete';
import { COUNTRY_CODES } from '../../mla-country/country-codes';
const MlaSubdivision = _ref => {
  let {
    options,
    countryCode,
    ...rest
  } = _ref;
  const fieldType = FIELD_TYPES.MLA_SUBDIVISION;
  const {
    t
  } = useTranslation();
  const countryCodeAlpha3 = countryCode ? COUNTRY_CODES[countryCode] : undefined;
  const label = useAddressLabel('subdivision');
  const {
    locale
  } = useConfig();
  const countryOptions = useMemo(() => {
    if (!countryCodeAlpha3) {
      return [];
    }
    const localizedOptions = (options || []).map(option => createOption({
      value: t("locale-dataset.states." + countryCodeAlpha3 + "." + option.value.toUpperCase()),
      id: option.value
    }));
    if (countryCodeAlpha3 === COUNTRY_CODES.JP) {
      return localizedOptions;
    }
    return localizedOptions.sort((a, b) => a.value.localeCompare(b.value, locale));
  }, [options, countryCodeAlpha3, t, locale]);
  return /*#__PURE__*/React.createElement(DropdownAutocomplete, _extends({}, rest, {
    fieldType: fieldType,
    label: label,
    options: countryOptions,
    countryCode: countryCode
  }));
};
export default MlaSubdivision;
//# sourceMappingURL=mla-subdivision.js.map